<script>
import { mapGetters } from 'vuex';
import { propertiesOrder } from '../../../models/filter';
import CompareListTableProductCell from './CompareListTableProductCell.vue';
import CompareListTablePropertyCell from './CompareListTablePropertyCell.vue';
import CompareListTableCartCell from './CompareListTableCartCell.vue';

export default {
  name: 'CompareListTable',
  components: {
    CompareListTableProductCell, CompareListTablePropertyCell, CompareListTableCartCell,
  },
  computed: {
    ...mapGetters({
      products: 'compare/products',
      options: 'compare/options',
      properties: 'compare/properties',
      highlightDifferences: 'compare/highlightDifferences',
    }),
    sortedProperties() {
      return this.properties
        .filter((property) => !['Couleur', 'Conseil'].includes(property.name))
        .slice()
        .concat([{ name: 'Certification' }]) // add only Certification from this.options
        .sort((a, b) => propertiesOrder.indexOf(a.name) - propertiesOrder.indexOf(b.name));
    },
  },
};
</script>

<template>
  <table class="min-w-full divide-y divide-orange-diagomics-light">
    <thead class="bg-gray-50">
      <tr class="divide-x divide-gray-200">
        <th class="w-1/4"></th>
        <th
          v-for="(product) in products"
          :key="product.id"
          class="py-6 md:w-1/4 px-6 relative"
        >
          <CompareListTableProductCell :product="product"/>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        class="even:bg-gray-50"
        v-for="property in sortedProperties" :key="property.id"
      >
        <td class="font-bold py-2 px-6">{{ $t(property.name.toLowerCase()) }}</td>
        <td
          is="CompareListTablePropertyCell"
          v-for="product in products"
          :key="product.id"
          :product="product"
          :property="property"
          class="py-2 px-6 border-l border-gray-diagomics"
        />
      </tr>
    </tbody>
    <thead class="bg-gray-50">
      <tr class="divide-x divide-gray-200">
        <th class="w-1/4"></th>
        <th
          v-for="(product) in products"
          :key="product.id"
          class="py-4 md:w-1/4 px-6 relative"
        >
          <CompareListTableProductCell :product="product"/>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td></td>
        <td
          is="CompareListTableCartCell"
          v-for="(product) in products"
          :key="product.id"
          :product="product"
          class="whitespace-nowrap py-4"
        />
      </tr>
    </tbody>
  </table>
</template>
